export default __webpack_public_path__ + "static/media/24_FRD_XBD_66823_DRFURC.b34d3f20.jpg";